import { useMsal } from "@azure/msal-react";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getViewAllDetailsEndpoint } from "../../../common/endpoints";
import ButtonComponent from "../../../components/common/button/Button";
import { Loader } from "../../../components/common/Loader";
import { getPowerBIMaterialDetailsData } from "../../../redux/actions/LTPlanner/PowerBIMaterialDetailsSlice";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import TopSection from "../TopSection";
import "./AnalyticsResults.css";
import LeadtimeModel from "./LeadTimeModal";

const ViewerAnalyticsResultsTab = (props) => {
  const role = localStorage.getItem("LTRole");
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();
  const combinedObject = location?.state?.combinedObject || {};
  const { instance } = useMsal();
  const [openViewAllModal, setOpenViewAllModal] = useState(false);
  const [viewAllData, setViewAllData] = useState({});
  const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
  const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
  const [powerBIReportID, setPowerBIReportID] = useState("");
  const [inventoryValueState, setInventoryValueState] = useState("");
  const [confidenceLevel, setConfidenceLevel] = useState(combinedObject?.data?.recomConfidenceLevel);
  const [formData, setFormData] = useState({
    LTData: combinedObject?.data?.finalLt,

    potentialImpact: combinedObject?.data?.potentialImpact

  });
  const handleChangeConfidenceLevel = (event, newValue) => {

    const currentConfidenceLevel = event.target.value;

    setConfidenceLevel(event.target.value);
    setFormData({
      LTData: currentConfidenceLevel === "75%" ? combinedObject?.data?.likelyFinalLt || 0 : currentConfidenceLevel === "65%" ? combinedObject?.data?.lessLikelyFinalLt || 0 : combinedObject?.data?.highLikelyFinalLt || 0,

      potentialImpact: `${Math.round((Math.sqrt(Number(currentConfidenceLevel === "75%" ? combinedObject?.data?.likelyFinalLt || 0 : currentConfidenceLevel === "65%" ? combinedObject?.data?.lessLikelyFinalLt || 0 : combinedObject?.data?.highLikelyFinalLt || 0) / Number(combinedObject?.data?.purchDocType === "Y1" ? combinedObject?.data?.contractLt?.split(" ")[0] : combinedObject?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`
    })
  };

  const onChangeFinalLT = (event) => {
    const isValidNumber = /^[0-9]*$/.test(event.target.value);

    if (isValidNumber) {
      setFormData({
        ...formData,
        LTData: event.target.value,
        potentialImpact: `${Math.round((Math.sqrt(Number(event.target.value || 0) / Number(combinedObject?.data?.purchDocType === "Y1" ? combinedObject?.data?.contractLt?.split(" ")[0] : combinedObject?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`
      })
    }
  }

  const getViewAllData = async () => {
    try {
      const responseViewAllDetails = await dispatch(getViewAllDetails({
        dynamicEndpoint: `${getViewAllDetailsEndpoint}/${combinedObject?.data?.runSeqId}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
        setViewAllData(responseViewAllDetails?.payload)
      } else {
        console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
        setViewAllData({})
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  const handleOpenViewAllModal = (row) => {
    setOpenViewAllModal(true);
    getViewAllData(row);
  }
  const handleCloseViewAllModal = () => {
    setOpenViewAllModal(false);
    setViewAllData({})
  }
  const group_id = process.env.REACT_APP_PBI_DEMONSTRATED_LT_GROUP_ID
  const report_id = process.env.REACT_APP_PBI_DEMONSTRATED_LT_REPORT_ID;

  const filter = [
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "material_poitem",
      },
      operator: "Equals",
      values: [combinedObject?.data?.materialId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "supplier",
      },
      operator: "Equals",
      values: [combinedObject?.data?.supplierId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "plant_poitem",
      },
      operator: "Equals",
      values: [combinedObject?.data?.plant],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "LTA_JOB_RUN_ID",
      },
      operator: "Equals",
      values: [combinedObject?.data?.runSeqId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "purchasingdocumenttype",
      },
      operator: "Equals",
      values: [combinedObject?.data?.purchDocType],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "PREDOMINANT_TRANSPORT_NAME",
      },
      operator: "Equals",
      values: [combinedObject?.data?.transportMode],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    }
  ];

  const incotermFilter = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "Month",
      column: "INCOTERSLOCATION1_POITEM",
    },
    operator: "Equals",
    values: [combinedObject?.data?.incotermLocation],
    filterType: models.FilterType.Basic,
    requireSingleSelection: true
  };

  const embedConfig = {
    type: 'report',
    id: powerBIReportID,
    embedUrl: `${powerBIEmbedURL}`,
    accessToken: powerBIAccessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      navContentPaneEnabled: false,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToWidth,
      },
    },
    filters: combinedObject?.data?.purchDocType === "YIC" ? filter : combinedObject?.data?.purchDocType === "YIP" ? filter : [...filter, incotermFilter]
  }

  useEffect(() => {
    const getPowerBIDetails = async () => {
      try {
        const responsePowerBIDetails = await dispatch(getPowerBIMaterialDetailsData({
          dynamicEndpoint: `api/powerBI/embedDetails/group/${group_id}/report/${report_id}`,
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          }
        }));
        if (responsePowerBIDetails?.meta?.requestStatus === 'fulfilled') {
          setPowerBIEmbedURL(responsePowerBIDetails?.payload?.embedUrl);
          setPowerBIReportID(responsePowerBIDetails?.payload?.reportId);
          setPowerBIAccessToken(responsePowerBIDetails?.payload?.accessToken)
        } else {
          toast.error(responsePowerBIDetails?.payload?.errorMessage, {
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error('API error:', error);
      }
    }
    getPowerBIDetails();

  }, []);

  useEffect(() => {
    const row = combinedObject?.data;
    const finalLt = combinedObject?.data?.finalLt;

    const currLt = Number(
      row?.purchDocType === "Y1"
        ? row?.contractLt?.split(" ")[0]
        : row?.activePirLt?.split(" ")[0]
    );

    const ratio = Math.sqrt(Number(finalLt) / currLt);
    const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

    const inventoryChange =
      (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
      row?.currentAvgStock;

    let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);
    setInventoryValueState(inventoryValue)
  }, []);

  const newSafetyStock = (() => {
    const currSafetyStock = Number(combinedObject?.data?.oldSafetyStock) || 0; /*777*/
    const newLt = Number(combinedObject?.data?.highLikelyFinalLt); /*54*/
    const oldLtValue = String(combinedObject?.data?.contractLt ?? "").trim(); /*111*/
    const oldLt = Number(oldLtValue.split(" ")[0]);
    if (!isFinite(currSafetyStock) || !isFinite(newLt) || !isFinite(oldLt) || oldLt === 0) {
      return currSafetyStock;
    }
    const result = currSafetyStock * Math.sqrt(newLt / oldLt);
    return isFinite(result) ? result : currSafetyStock;
  })();

  const newInventory = (() => {
    const currentAvgStock = Number(combinedObject?.data?.currentAvgStock) || 0;
    const currentSafetyStock = Number(combinedObject?.data?.oldSafetyStock) || 0;
    if (!isFinite(currentAvgStock) || !isFinite(currentSafetyStock) || !isFinite(newSafetyStock)) {
      return currentAvgStock;
    }
    const result = currentAvgStock - currentSafetyStock + newSafetyStock;
    return isFinite(result) ? result : currentAvgStock;
  })();

  const actualStockImpactPercent = (() => {
    const currentStock = Number(combinedObject?.data?.currentAvgStock);
    if (!isFinite(currentStock) || currentStock === 0 || !isFinite(newInventory)) {
      return 0;
    }
    const raw = ((newInventory - currentStock) / currentStock) * 100;
    const absolutePercent = Math.abs(raw);
    return isFinite(absolutePercent) ? Math.round(absolutePercent) : 0;
  })();

  const actualImpactPercent = isFinite(actualStockImpactPercent) ? `${actualStockImpactPercent}%` : "-";

  const actualInventoryImpact = (() => {
    const currentAvgStock = Number(combinedObject?.data?.currentAvgStock);
    if (!isFinite(currentAvgStock) || !isFinite(newInventory)) {
      return 0;
    }
    return newInventory - currentAvgStock;
  })();

  return (
    <div>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Analytics Results", path: "/viewer-analytics-results" },
          { title: "Results" },
        ]}
        tabTitle="Workflow Management"
      />
      <div className="analytic-results-tab">
        <div className="analytic-results-top-section">

          <div className="result-item">
            <span className="analytics-text">
              Period Consider for Analytics
            </span>
            <p>{combinedObject?.data?.periodConsidered || "-"}</p>
          </div>
          <div className="result-item">
            <span className="analytics-text">Analytics Initiated by</span>
            <p>{combinedObject?.data?.ltInitiatedBy || "-"}</p>
          </div>
          <div className="result-item">
            <span className="analytics-text">Analytics Run Unique ID</span>
            <p>{combinedObject?.data?.runOutputSeqId || "-"}</p>
          </div>
        </div>
        <div className="input-details">
          <p >
            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={handleOpenViewAllModal}>Click Here</span>
            &nbsp;to View the Complete Input Details
          </p>
          <div>
            <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
          </div>
        </div>

      </div>
      {/* <div style={{ margin: "10px 0px", textAlign: "center" }}>
        <iframe title="LTResultsupdated" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=ed64bb79-a6dd-4c23-a33a-5a41930b849e&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c&navContentPaneEnabled=false" frameborder="0" allowFullScreen="true"></iframe>
      </div> */}
      {stateSelector?.PowerBIMaterialDetailsSlice?.loading ? <Loader /> :
        <div className="powerBi_cls">
          {embedConfig?.embedUrl && embedConfig?.accessToken &&
            <PowerBIEmbed
              embedConfig={embedConfig}
              getEmbeddedComponent={(embedObject) => {
                window.report = embedObject;
              }}
            />}
        </div>}

      <div className="analytic-results-tab result-margin" style={{ padding: '20px 10px' }}>
        <div style={{ margin: '0px 0px 10px 10px', border: '2px solid #ccc', padding: '10px', borderRadius: '5px', maxWidth: '400px' }}>
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', marginBottom: '10px' }}>Potential Impact of New Lead Time on Stock : </span>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '5px'}}>
              <div style={{margin: "0px 10px 0px 10px"}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>Planned<b style={{ marginLeft: 5 }}>{formData?.potentialImpact?.replace("-", "").trim() || "-"}</b> <span>
                {
                  Number(formData?.potentialImpact?.replace("%", "").trim()) >= 0 ?
                    <ArrowUpwardIcon style={{ color: 'red', fontSize: 20 }} /> : <ArrowDownwardIcon style={{ color: 'green', fontSize: 20 }} />
                }</span></span>  
              </div> 
              <div style={{marginLeft: "10px"}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>Actual<b style={{ marginLeft: 5 }}>{actualImpactPercent}</b>
                  <span>
                    {
                      Number(formData?.potentialImpact?.replace("%", "").trim()) >= 0 ?
                        <ArrowUpwardIcon style={{ color: 'red', fontSize: 20 }} /> : <ArrowDownwardIcon style={{ color: 'green', fontSize: 20 }} />
                    }
                  </span>
                </span>
              </div>
            </div>
        </div>
        <div style={{ margin: '0px 0px 10px 10px', border: '2px solid #ccc', padding: '10px', borderRadius: '5px', maxWidth: '400px' }}>
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', marginBottom: '10px' }}>Potential Inventory Impact (Cost Value) : </span>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '5px'}}>
              <div style={{margin: "0px 10px 0px 10px"}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>Planned<b style={{ marginLeft: 5 }}>
                  {combinedObject?.data?.currency === "USD" || !combinedObject?.data?.usdExchangeRate || combinedObject?.data?.usdExchangeRate === 0
                    ? `${inventoryValueState || "0.00"} ${combinedObject?.data?.currency || ""}`
                    : `${(inventoryValueState * combinedObject?.data?.usdExchangeRate).toFixed(2)} USD`}
                </b></span>   
              </div>
              <div style={{marginLeft: "10px"}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>Actual
                  <b style={{ marginLeft: 5 }}>
                  {combinedObject?.data?.currency === "USD" || !combinedObject?.data?.usdExchangeRate || combinedObject?.data?.usdExchangeRate === 0
                    ? `${actualInventoryImpact || "0.00"} ${combinedObject?.data?.currency || ""}`
                    : `${(actualInventoryImpact * combinedObject?.data?.usdExchangeRate).toFixed(2)} USD`}
                  </b>
                </span>
              </div>
            </div>
        </div>
        <div>

          <div className="recommondation_Section">
            <span id="recommondation_header">Recommendations:</span>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="analytic-results left-recommendation">
              <div>
                <div className="result-item-rec">
                  <span>
                    % of orders with lower than recommended lead time
                  </span>
                  {/* <p style={{ display: 'flex', alignItems: 'center', gap: 2 }}>: <Dropdown
                    name="confidenceLevel"
                    value={confidenceLevel}
                    options={[
                      { value: "85%", label: "85%" },
                      { value: "75%", label: "75%" },
                      { value: "65%", label: "65%" },
                    ]}
                    handleChange={handleChangeConfidenceLevel}
                    height="35px"
                    width="150px"
                    styles={{ backgroundColor: '#fff' }}
                    disabled={role === "Admin" || combinedObject?.activeItem === "Closed Workflow Items" || (combinedObject?.data?.currentApprovalLevel > 0)}
                  /></p> */}
                  <p>: {confidenceLevel}</p>
                </div>

                <div className="result-item-rec">
                  <span>
                    Mode of Transport Considered for Recommendation
                  </span>
                  <p>: {combinedObject?.data?.transModeConsidered}</p>
                </div>
                <div className="result-item-rec">
                  <span>
                    Recommended LT to be Updated in S/4 (Planned)
                  </span>
                  <p>: {formData.LTData}</p>
                </div>
              </div>

            </div>
            {/* <div className="right-recommendation">
              <div className="result-item" style={{ marginBottom: '10px', marginTop: 0 }}>
                <span style={{ marginBottom: 5 }}>
                  Recommended LT to be Updated in S/4
                </span>
                <ActionInput
                  // className="text-input"
                  name="finalLT"
                  props={{ height: "35px", maxWidth: "250px" }}
                  value={formData.LTData}
                  borderRadius="5px"
                  width="246px"
                  onChange={onChangeFinalLT}
                  disabled={role === "Admin" || combinedObject?.activeItem === "Closed Workflow Items" || (combinedObject?.data?.currentApprovalLevel > 0)}
                />
                <span id="helperText">Note: Please enter only numbers</span>
              </div>
            </div> */}
          </div>
        </div>

      </div>
      <div className="analytic-results-buttons result-margin">
        <div className="analytic-results" style={{ width: "30%" }}>
          <ButtonComponent
            type="primary"
            maxWidth="80px"
            label="Back"
            onClick={() => navigate("/viewer-analytics-results", { state: combinedObject?.landingTitle })}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewerAnalyticsResultsTab;
